import { useCallback, useMemo } from 'react';
import { useGetTransferBatches } from '@frameio/transfers/hooks';
import type { TransferBatchIds } from '@frameio/transfers/hooks/useDeleteTransferBatches';
import { useDeleteTransferBatches } from '@frameio/transfers/hooks/useDeleteTransferBatches';
import { isInTerminalState } from '@frameio/transfers/utils';
import { MenuButton } from '@frameio/vapor';
import { IconTrash } from '@frameio/vapor-icons';
import TEXT from './generated/TEXT/MenuClearUploadsButton';

TEXT.DEFINE({
  /** Context menu action label that clears completed/failed uploads from the uploads list */
  title: 'Clear Uploads',
});

export const MenuClearUploadsButton = () => {
  const { data: batches } = useGetTransferBatches();
  const { deleteTransferBatches } = useDeleteTransferBatches();

  const terminalBatchIds: TransferBatchIds[] = useMemo(() => {
    if (!batches) return [];

    return batches
      .filter((batch) => batch.status === null || isInTerminalState(batch))
      .map((batch) => ({ id: batch.id }));
  }, [batches]);

  const onClearList = useCallback(() => {
    deleteTransferBatches(terminalBatchIds);
  }, [terminalBatchIds, deleteTransferBatches]);

  return (
    <MenuButton
      disabled={terminalBatchIds.length === 0}
      iconBefore={<IconTrash />}
      onClick={() => onClearList()}
    >
      {TEXT.title}
    </MenuButton>
  );
};
